import React, { useState } from "react";

const API_BASE = window.location.hostname.includes("localhost")
  ? "http://localhost:8000"
  : `https://api.${window.location.hostname.replace(/^www\./, "")}`;  // api.{project}.{domain}

function App() {
  const [health, setHealth] = useState(null);
  const [items, setItems] = useState([]);
  const [info, setInfo] = useState(null);
  const [error, setError] = useState(null);

  const fetchHealth = async () => {
    try {
      const res = await fetch(`${API_BASE}/api/health`);
      setHealth(await res.json());
      setError(null);
    } catch (e) {
      setError(`Cannot reach backend: ${e.message}`);
    }
  };

  const fetchInfo = async () => {
    try {
      const res = await fetch(`${API_BASE}/api/info`);
      setInfo(await res.json());
      setError(null);
    } catch (e) {
      setError(`Cannot reach backend: ${e.message}`);
    }
  };

  const fetchItems = async () => {
    try {
      const res = await fetch(`${API_BASE}/api/items`);
      const data = await res.json();
      setItems(data.items || []);
      setError(null);
    } catch (e) {
      setError(`Cannot reach backend: ${e.message}`);
    }
  };

  return (
    <div style={{ padding: "2rem", fontFamily: "sans-serif" }}>
      <h1>Hello, World!</h1>

      <h2>Backend Integration</h2>
      {error && <p style={{ color: "red" }}>{error}</p>}

      <div style={{ display: "flex", gap: "1rem", marginBottom: "1rem" }}>
        <button onClick={fetchHealth}>Check Health</button>
        <button onClick={fetchInfo}>Get Info</button>
        <button onClick={fetchItems}>Load Items</button>
      </div>

      {health && <pre>{JSON.stringify(health, null, 2)}</pre>}
      {info && <pre>{JSON.stringify(info, null, 2)}</pre>}

      {items.length > 0 && (
        <ul>
          {items.map((item) => (
            <li key={item.id}>
              <strong>{item.name}</strong> — {item.description}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

export default App;
